import React from 'react';

import classNames from 'classnames';

import { Welcome } from '@atoms/welcome/Welcome';
import { isMobile, isTablet } from '@constants/breakpoints';
import { WelcomeMessage } from '@constants/messages';
import { useUserSettings } from '@hooks/useUserSettings';
import { useWindowDimentions } from '@hooks/useWindowDimentions';
import { PanelBlock } from '@molecules/panelBlock/PanelBlock';
import { QuickAccess } from '@organisms/home/quickAccess/QuickAccess';
import { WatchList } from '@organisms/home/watchList/WatchList';
import { useAppSelector } from '@store/index';

import styles from './HomeTemplate.module.less';

export const HomeTemplate = () => {
    const { isOrderWatchlistEnabled, isQuickAccessEnabled, isDarkModeEnabled } =
        useUserSettings();

    const lastName = useAppSelector((state) => state.user.userInfo.lastName);
    const firstName = useAppSelector((state) => state.user.userInfo.firstName);
    const { width } = useWindowDimentions();
    const isMobileVersion = isMobile(width) || isTablet(width);

    return (
        <PanelBlock
            fullHeight={true}
            fullWidth={true}
            contentClassName={styles.ContentWrapper}
        >
            <div
                className={classNames(styles.Container, {
                    [styles.Container__Mobile]: isMobileVersion
                })}
            >
                <Welcome
                    name={firstName}
                    lastName={lastName}
                    welcomeMessage={WelcomeMessage}
                />
                {isQuickAccessEnabled && (
                    <QuickAccess
                        isMobileVersion={isMobileVersion}
                        isDarkModeEnabled={isDarkModeEnabled}
                    />
                )}
                {isOrderWatchlistEnabled && (
                    <WatchList
                        isMobileVersion={isMobileVersion}
                        isDarkModeEnabled={isDarkModeEnabled}
                    />
                )}
            </div>
        </PanelBlock>
    );
};
